import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { MessageService, MovimentacoesService } from '@services';
import { getErrorMessage } from '@utils';
import { DocumentosAnexosViewModel } from 'models/documentos-anexos/DocumentosAnexosViewModel';
import { DimDatatableColumn } from '@models';
import * as saveAs from 'file-saver';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-modal-download-anexos-movimentacoes',
  templateUrl: './modal-download-anexos-movimentacoes.component.html',
  styleUrls: ['./modal-download-anexos-movimentacoes.component.css']
})
export class ModalDownloadAnexosMovimentacoesComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal;
  documentosAnexos: DocumentosAnexosViewModel[] = [];
  colunasDocumentosAnexos: DimDatatableColumn[] = [
    { label: 'Nome do arquivo', col: 'nomeArquivo', hide: true },
  ];

  constructor(
    private messageService: MessageService,
    private movimentacoesService: MovimentacoesService
  ) {
    super();
  }

  ngOnInit() {
    this.consultarDocumentosAnexos();
  }

  show() {
    this.modal.show();
  }

  fechar() {
    this.closed.emit();
  }

  async consultarDocumentosAnexos() {
    try {
      this.loading['request'] = true;
      this.documentosAnexos = await lastValueFrom(this.movimentacoesService.consultarDocumentosAnexos(this.prop));
    } catch (err) {
      console.error(err);
      this.messageService.error(getErrorMessage(err), 8000);
    } finally {
      this.loading['request'] = false;
    }
  }

  async downloadProdutoDocumentoAnexo(documento) {
    try {
      this.loading['downloadAnexo'] = true;
      const anexoBlob = await lastValueFrom(this.movimentacoesService.downloadAnexoMovimentacao(documento.id));
      saveAs(anexoBlob, documento.nomeArquivo);
    } catch (e) {
      console.error(e);
      this.messageService.error('Falha ao baixar anexo.', 0, 'Erro');
    } finally {
      this.loading['downloadAnexo'] = false;
    }
  }
}
